// extracted by mini-css-extract-plugin
export default {"header":"tS-z","isActive":"uS-z"};